import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { registryApiPathPrefix, registryServiceURL, routerServiceURL } from './defines';
import { getCurrentProjectId } from '../../common/context/project-storage';
import { getAuthToken } from '../../common/context/auth/storage';
import { getRouterApiKey } from '../../common/context/router-api-key-storage';

const generateCorrelationId = () => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `cid-${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

export const baseQueryRegistry = fetchBaseQuery({
  baseUrl: `${registryServiceURL}${registryApiPathPrefix}`,
  prepareHeaders: (headers) => {
    headers.set('Content-Type', 'application/json');
    headers.set('x-correlation-id', generateCorrelationId());
    const authToken = getAuthToken();
    if (authToken) {
      headers.set('Authorization', `Bearer ${authToken}`);
    }
    const projectId = getCurrentProjectId();
    if (projectId) {
      headers.set('x-project-id', projectId);
      const routerApiKey = getRouterApiKey(projectId);
      if (routerApiKey) {
        headers.set('x-api-key', routerApiKey);
      }
    }
    return headers;
  },
});

export const baseQueryRouter = fetchBaseQuery({
  baseUrl: routerServiceURL,
  prepareHeaders: (headers) => {
    headers.set('Content-Type', 'application/json');
    headers.set('x-correlation-id', generateCorrelationId());
    const projectId = getCurrentProjectId();
    if (projectId) {
      headers.set('x-project-id', projectId);
    }
    return headers;
  },
});
